module.exports = __webpack_public_path__ + "static/media/crisis_alert.1c52be4b.svg";